export default {"src":"/_next/static/media/ReviewsIoLogoBlack.80f90059.svg","height":20,"width":122,"blurWidth":0,"blurHeight":0};